import { isValidMotionProp, motion } from "framer-motion";
import ScrollFloat from "../component/ScrollFloat";
import Solutions from "../component/Solutions";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function About() {
  return (
    <>
      <Helmet>
        <title>About Blockcryp | Expert Blockchain Development Company</title>
        <meta
          name="description"
          content=" Learn about Blockcryp – a leading blockchain development company offering secure, scalable solutions in DeFi, NFTs, crypto exchanges, and smart contracts."
        />
        <meta
          name="keywords"
          content="blockchain development company, Web3 development services, smart contract developers, DeFi development experts, NFT marketplace developers, crypto exchange development, blockchain technology company, enterprise blockchain solutions, decentralized app development, custom blockchain development"
        />
      </Helmet>
      {/* ---------- hreo section start ---------- */}
      <section className="margintop">
        <div className="container">
          <div className="">
            <motion.h1
              initial={{ opacity: 0, y: -50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="heading_h1 text-center fw-semibold mb-4"
            >
              Our mission is to <br />
              bring <span className="text-primary">web3</span> to the mainstream
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: -50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="pera_txt text-center mb-4"
            >
              We provide a robust fiat cryptocurrency toolbox that makes it
              simple for anybody to enrol their next million customers into
              web3.
            </motion.p>
          </div>
          <div className="row justify-content-center align-items-center mt-md-5 mt-0 pt-md-3 pt-0">
            <div className="col-lg-3 col-md-3 col-sm-6 blockcryp_border">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="blockcryp_number"
              >
                <div className="x">
                  <span className="heading_h2 fw-bold text-primary">500+</span>
                </div>
                <div className="pera_txt">Crypto currencies Integrated</div>
              </motion.div>
            </div>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="col-lg-3 col-md-3 col-sm-6 blockcryp_border"
            >
              <div className="blockcryp_number">
                <div className="x">
                  <span className="heading_h2 fw-bold text-primary">20+</span>
                </div>
                <div className="pera_txt">Network supported</div>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="col-lg-3 col-md-3 col-sm-6 blockcryp_border"
            >
              <div className="blockcryp_number">
                <div className="x">
                  <span className="heading_h2 fw-bold text-primary">150+</span>
                </div>
                <div className="pera_txt">Currency Listed in CMC & CG</div>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="col-lg-3 col-md-3 col-sm-6"
            >
              <div className="blockcryp_number2">
                <div className="x">
                  <span className="heading_h2 fw-bold text-primary">$100M</span>
                </div>
                <div className="pera_txt">Crypto currencies Integrated</div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ---------- over company section start ---------- */}
      <section className="our_company space60">
        <div className="container">
          <div className="row align-items-center g-4">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="col-lg-6 order-lg-1 order-2"
            >
              <p className="text_16 text-primary">OUR COMPANY</p>
              <h3 className="heading_h3 fw-bold">Who we are</h3>
              <p className="pera_txt">
                Blockcryp is a worldwide financial technology firm developing
                ways to integrate the cryptocurrency market with the established
                financial system.
              </p>
              <p className="pera_txt">
                We have been developing and enhancing our core blockchain and
                web3 technologies since 2017 in an effort to bring web3 into the
                public in a safe and legal manner.
              </p>
              <p className="pera_txt">
                Blockcryp has operations in the UK and India and employs more
                than 160 employees worldwide.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="col-lg-6 order-lg-2 order-1"
            >
              <ImageWithSkeleton
                src="assets/images/about/company3.webp"
                alt=""
                className="w-100"
              />
              {/* <img
                src="assets/images/about/company2.webp"
                alt="about"
                className="about_company"
              /> */}
            </motion.div>
          </div>
        </div>
      </section>

      {/* ---------- over vision section start ---------- */}
      <section className="our_vision space60">
        <div className="container">
          <div className="row align-items-center g-4">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="col-lg-6 pe-lg-5"
            >
              <ImageWithSkeleton
                src="assets/images/about/vision3.webp"
                alt=""
                className="w-100"
              />
              {/* <img
                src="assets/images/about/vision2.webp"
                alt="about"
                className="about_company"
              /> */}
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="col-lg-6"
            >
              <p className="text_16 text-primary">OUR VISION</p>
              <h3 className="heading_h3 fw-bold">Building the new economy</h3>
              <p className="pera_txt">
                Value creation and distribution are two more areas that are
                being revolutionised by blockchain and tokenization.
              </p>
              <p className="pera_txt">
                We're using this tech to create a more fair and prosperous
                economy that benefits everyone, not just the wealthy few.
              </p>
              {/* <p className="text_16 text-primary">MEMBER OF</p>
              <div className="d-flex justify-content-start gap-5">
                <img
                  src="assets/images/about/deo.jpg"
                  alt="deo"
                  className="member_partner"
                />
                <img
                  src="assets/images/about/web3.png"
                  alt="web"
                  className="member_partner"
                />
                <img
                  src="assets/images/about/eth.png"
                  alt="eth"
                  className="member_partner"
                />
              </div> */}
            </motion.div>
          </div>
        </div>
      </section>

      {/* ---------- over value section start ---------- */}
      <section className="our_value margintop">
        <div className="container">
          <div className="space80">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="text-center">
                  {/* <p className="para_txt text-primary">OUR VALUESS</p> */}
                  <ScrollFloat
                    animationDuration={1}
                    ease="back.inOut(2)"
                    scrollStart="center bottom+=50%"
                    scrollEnd="bottom bottom-=40%"
                    stagger={0.09}
                    textClassName="heading_h2 fw-bold text-light mb-4"
                  >
                    What we <b textClassName="text-primary"> believe </b> in
                  </ScrollFloat>
                </div>
              </div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="col-lg-3 col-sm-6 col-md-6 col-xs-6 mt-4"
              >
                <div className="value_center text-light text-center d-flex justify-content-center flex-column align-items-center">
                  <div className="values_icon d-flex justify-content-center align-items-center bg-primary">
                    <img
                      src="assets/images/about/valueicon1.svg"
                      alt="value icon"
                    />
                  </div>
                  <h5 className="heading_h5">Inclusive</h5>
                  <p className="">
                    To make web3 accessible to everyone, everywhere
                  </p>
                </div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="col-lg-3 col-sm-6 col-md-6 col-xs-6 mt-4"
              >
                <div className="value_center text-light text-center d-flex flex-column align-items-center">
                  <div className="values_icon d-flex justify-content-center align-items-center bg-primary">
                    <img
                      src="assets/images/about/valueicon2.svg"
                      alt="value icon"
                    />
                  </div>
                  <h5 className="heading_h5">Efficient</h5>
                  <p className="">
                    To offer an automated and frictionless experience
                  </p>
                </div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="col-lg-3 col-sm-6 col-md-6 col-xs-6 mt-4"
              >
                <div className="value_center text-light text-center d-flex flex-column align-items-center">
                  <div className="values_icon d-flex justify-content-center align-items-center bg-primary">
                    <img
                      src="assets/images/about/valueicon3.svg"
                      alt="value icon"
                    />
                  </div>
                  <h5 className="heading_h5">Reliable</h5>
                  <p className="">
                    To be as transparent and verifiable as we can
                  </p>
                </div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="col-lg-3 col-sm-6 col-md-6 col-xs-6 mt-4"
              >
                <div className="value_center text-light text-center d-flex flex-column align-items-center">
                  <div className="values_icon d-flex justify-content-center align-items-center bg-primary">
                    <img
                      src="assets/images/about/valueicon4.svg"
                      alt="value icon"
                    />
                  </div>
                  <h5 className="heading_h5">Complaint</h5>
                  <p className="">
                    To engage regulators and comply with existing rules
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- over vision,company section start ---------- */}
      <section className="our_value_vision space60">
        <div className="container">
          <div className="row justify-content-md-start text-md-start justify-content-center text-center g-4">
            <div className="col-lg-6">
              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="text_16 text-primary"
              >
                OUR VISION
              </motion.p>
              <motion.h3
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-bold"
              >
                Building the new economy
              </motion.h3>
              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt"
              >
                Their visionary leadership has led Blockcryp to the forefront
                of the blockchain revolution, where trust is no longer
                centralized but distributed across the network.
              </motion.p>
            </div>
            <div className="col-lg-6">
              <div className="row g-3">
                <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="vision_avatar"
                  >
                    <img
                      src="assets/images/about/av1.webp"
                      alt=""
                      className="about_avatar"
                    />
                    <p className="mb-1">Aman Vaths</p>
                    <p className="mb-1">CTO & Founder</p>
                    <div className="d-flex justify-content-md-start justify-content-center gap-2">
                      <i class="fa-brands fa-twitter pera_txt"></i>
                      <i class="fa-brands fa-linkedin pera_txt"></i>
                    </div>
                  </motion.div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="vision_avatar"
                  >
                    <img
                      src="assets/images/about/av2.webp"
                      alt=""
                      className="about_avatar"
                    />
                    <p className="mb-1">Naman Singh</p>
                    <p className="mb-1">CEO & Co-Founder</p>
                    <div className="d-flex justify-content-md-start justify-content-center gap-2">
                      <i className="fa-brands fa-twitter pera_txt"></i>
                      <i className="fa-brands fa-linkedin pera_txt"></i>
                    </div>
                  </motion.div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="vision_avatar"
                  >
                    <img
                      src="assets/images/about/av3.webp"
                      alt=""
                      className="about_avatar"
                    />
                    <p className="mb-1">Wazid Khan</p>
                    <p className="mb-1">Director & Co-Founder</p>
                    <div className="d-flex justify-content-md-start justify-content-center gap-2">
                      <i className="fa-brands fa-twitter pera_txt"></i>
                      <i className="fa-brands fa-linkedin pera_txt"></i>
                    </div>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="our_value_vision space60">
        <div className="container">
          <div className="row justify-content-md-start text-md-start justify-content-center text-center g-4">
            <div className="col-lg-6">
              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="text_16 text-primary"
              >
                OUR COMPANY
              </motion.p>
              <motion.h3
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-bold"
              >
                Senior management
              </motion.h3>
              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt"
              >
                Our top management is made up of individuals with extensive
                backgrounds in both traditional and cutting-edge sectors of the
                business world.
              </motion.p>
            </div>
            <div className="col-lg-6">
              <div className="row g-3">
                <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="vision_avatar"
                  >
                    <img
                      src="assets/images/about/av4.webp"
                      alt=""
                      className="company_avatar"
                    />
                    <p className="mb-1">Aman Vaths</p>
                    <p className="mb-1">CTO & Founder</p>
                    <div className="d-flex justify-content-md-start justify-content-center gap-2">
                      <i class="fa-brands fa-twitter pera_txt"></i>
                      <i class="fa-brands fa-linkedin pera_txt"></i>
                    </div>
                  </motion.div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="vision_avatar"
                  >
                    <img
                      src="assets/images/about/av5.webp"
                      alt=""
                      className="company_avatar"
                    />
                    <p className="mb-1">Naman Singh</p>
                    <p className="mb-1">CEO & Co-Founder</p>
                    <div className="d-flex justify-content-md-start justify-content-center gap-2">
                      <i class="fa-brands fa-twitter pera_txt"></i>
                      <i class="fa-brands fa-linkedin pera_txt"></i>
                    </div>
                  </motion.div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="vision_avatar"
                  >
                    <img
                      src="assets/images/about/av6.webp"
                      alt=""
                      className="company_avatar"
                    />
                    <p className="mb-1">Wazid Khan</p>
                    <p className="mb-1">Director & Co-Founder</p>
                    <div className="d-flex justify-content-md-start justify-content-center gap-2">
                      <i class="fa-brands fa-twitter pera_txt"></i>
                      <i class="fa-brands fa-linkedin pera_txt"></i>
                    </div>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- over company believe section start ---------- */}
      <section className="space80 services">
        <div className="container">
          <div className="row g-4 justify-content-center">
            <div className="col-12">
              {/* <p className="text_16 text-primary text-center">OUR COMPANY</p> */}
              <motion.h2
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h2 fw-bold text-center"
              >
                What we <span className="text-primary"> believe </span> in
              </motion.h2>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="company_card h-100"
              >
                <img
                  src="assets/images/about/the-print.png"
                  alt=""
                  className="company_brand mb-4"
                />
                <p className="mb-5">
                  Blockcryp partners with top tech firm to drive global SaaS
                  innovation and growth.
                </p>
                <p className="pera_txt text-primary">Read full Article</p>
              </motion.div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="company_card h-100"
              >
                <img
                  src="assets/images/about/xpert-times.png"
                  alt=""
                  className="company_brand mb-4"
                />
                <p className="mb-5">
                  Blockcryp – Leading blockchain, DeFi and metaverse
                  innovation with advanced tech.
                </p>
                <p className="pera_txt text-primary">Read full Article</p>
              </motion.div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="company_card h-100"
              >
                <img
                  src="assets/images/about/time-bulletin-logo.png"
                  alt=""
                  className="company_brand mb-4"
                />
                <p className="mb-5">
                  Blockcryp Building Blockchain for A Safe and Sustainable
                  Environment.
                </p>
                <p className="pera_txt text-primary">Read full Article</p>
              </motion.div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="company_card h-100"
              >
                <img
                  src="assets/images/about/business-up.png"
                  alt=""
                  className="company_brand mb-4"
                />
                <p className="mb-5">
                  Blockcryp’ “Eigenphi MEV” Bot: Revolutionizing Crypto
                  Trading
                </p>
                <p className="pera_txt text-primary">Read full Article</p>
              </motion.div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="company_card h-100"
              >
                <img
                  src="assets/images/about/hello-entrepreneurs.png"
                  alt=""
                  className="company_brand mb-4"
                />
                <p className="mb-5">
                  Blockcryp “Eigenphi MEV” Bot: A New Milestone in Blockchain
                </p>
                <p className="pera_txt text-primary">Read full Article</p>
              </motion.div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="company_card h-100"
              >
                <img
                  src="assets/images/about/abp-live.png"
                  alt=""
                  className="company_brand mb-4"
                />
                <p className="mb-5">
                  How Blockcryp Achieved Top Rank in Custom Blockchain
                  Development
                </p>
                <p className="pera_txt text-primary">Read full Article</p>
              </motion.div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="company_card h-100"
              >
                <img
                  src="assets/images/about/cointrust.png"
                  alt=""
                  className="company_brand mb-4"
                />
                <p className="mb-5">
                  Blockcryp Pioneering Custom Blockchain Development
                </p>
                <p className="pera_txt text-primary">Read full Article</p>
              </motion.div>
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="company_card h-100"
              >
                <img
                  src="assets/images/about/mid-day.png"
                  alt=""
                  className="company_brand mb-4"
                />
                <p className="mb-5">
                  How Blockcryp Leads in DeFi Smart Contract Development and
                  Revolutionizes Traditional Banking
                </p>
                <p className="pera_txt text-primary">Read full Article</p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- over career section start ---------- */}
      <section className="career space60">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-6 col-12">
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="text-center mb-4"
              >
                {/* <p className="text_16 text-primary text-center">CAREER</p> */}
                <h2 className="heading_h2 fw-bold">
                  Find up your <span className="text-primary"> career</span>
                </h2>
                <p className="pera_txt">
                  We are looking for exceptionally talented people to join our
                  team and help us on our mission to take web3 to everyone.
                </p>
                <button class="button theme_btn mt-4" type="submit">
                  Check Web3 Jobs
                </button>
              </motion.div>
            </div>
            <div className="col-12 mt-5">
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="d-flex justify-content-center flex-wrap gap-3"
              >
                <img
                  src="assets/images/about/career1.webp"
                  alt=""
                  className="career_img"
                />
                <img
                  src="assets/images/about/career2.webp"
                  alt=""
                  className="career_img mt-lg-4"
                />
                <img
                  src="assets/images/about/career3.webp"
                  alt=""
                  className="career_img"
                />
                <img
                  src="assets/images/about/career4.webp"
                  alt=""
                  className="career_img mt-lg-4"
                />
                <img
                  src="assets/images/about/career5.webp"
                  alt=""
                  className="career_img"
                />
                <img
                  src="assets/images/about/career6.webp"
                  alt=""
                  className="career_img mt-lg-4"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <Solutions />
      {/* ---------- over solution section start ---------- */}
      {/* <section className="solution_bg space40">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-md-6 order-md-1 order-2">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="text-light"
              >
                <h3 className="heading_h3 fw-bold mb-3">
                  Solutions That Solve Real Challenges
                </h3>
                <p className="mb-md-5 mb-0">
                  Be it a DeFi, crypto exchange, or metaverse infrastructure,
                  our professional team offers comprehensive blockchain
                  solutions that solve, scale, and stand out.
                </p>
                <button
                  className="button theme_btn mt-4 mt-lg-0"
                  type="submit"
                >
                  Talk To Our Team!
                </button>
              </motion.div>
            </div>
            <div className="col-md-6 order-md-2 order-1">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="d-flex justify-content-center"
              >
                <img src="assets/images/about/solution.webp" alt="" />
              </motion.div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}
